<div
  id="header"
  class="flex justify-between items-center px-2 md:px-3 py-1 w-full h-full text-white"
  [ngClass]="[showLegend ? 'bg-black' : 'bg-main-dark']">
  <!-- LOGO & CLUB NAME -->
  <div class="hidden md:flex items-center mr-6">
    @if (!isNotFoundRoute()) {
      <ng-container>
        <img
          [ngSrc]="configurationService.configuration.logo"
          alt="Club logo"
          class="h-12"
          width="48"
          height="48"
          [priority]="false" />
        <div class="flex items-center h-10">
          <h3 class="ml-3 min-w-max">
            {{ configurationService.configuration.clientName }}
          </h3>
          @if (!landing && event) {
            <ng-container>
              <div class="mx-5 border-current border-l h-full"></div>
              <h5
                [title]="event.description"
                class="max-w-56 overflow-hidden text-nowrap">
                {{ event.description }}
              </h5>
              <div class="mx-5 border-current border-l h-full"></div>
              <h5
                [title]="formattedEventDate"
                class="hidden lg:flex justify-center items-center mr-2 text-nowrap">
                <span class="mr-1 font-normal"></span>
                {{ formattedEventDate }}
                <span class="hidden lg:flex text-xs">
                  (All Times {{ eventTimeZone }}. Subject to change.)
                </span>
              </h5>
            </ng-container>
          }
        </div>
      </ng-container>
    }
  </div>
  <!-- Mobile -->
  <div class="md:hidden flex items-center mr-6">
    @if (
      backBtn === 'checkout' || backBtn === 'payment' || backBtn === 'summary'
    ) {
      <div>
        <sdc-button
          className="flex justify-center items-center !bg-transparent disabled:opacity-30 !p-0 rounded-full !w-9 !min-w-0 !h-9 disabled:hover:transform-none hover:scale-95 transition-transform"
          theme="theme-sdc"
          type="button"
          variant="secondary"
          (onClick)="goBack(backBtn)">
          <img
            ngSrc="/assets/img/arrow-left-white-mobile-icon.svg"
            alt="Arrow left white icon"
            width="10"
            height="10" />
        </sdc-button>
      </div>
    } @else if (isSectionMap || is3dOpen) {
      <div>
        <sdc-button
          className="flex justify-center items-center !bg-transparent disabled:opacity-30 !p-0 rounded-full !w-9 !min-w-0 !h-9 disabled:hover:transform-none hover:scale-95 transition-transform"
          theme="theme-sdc"
          type="button"
          variant="secondary"
          (onClick)="goBackToTopview()">
          <img
            ngSrc="/assets/img/arrow-left-white-mobile-icon.svg"
            alt="Arrow left white icon"
            width="10"
            height="10" />
        </sdc-button>
      </div>
    }
    @if (!isNotFoundRoute()) {
      <ng-container>
        <img
          [ngSrc]="configurationService.configuration.logo"
          [priority]="true"
          alt="Club logo"
          width="32"
          height="32" />
        <h5 class="ml-2 min-w-max">
          {{ configurationService.configuration.clientName }}
        </h5>
      </ng-container>
    }
  </div>

  <!-- SEAT-SELECTION -->
  @if (showLegend && !is3dOpen) {
    <div class="hidden xl:flex items-center ml-6">
      <div id="legend" class="flex overflow-hidden text-ellipsis text-nowrap">
        <p class="hidden xl:flex mr-1 xl:mr-3">Legend:</p>
        <div class="flex items-center mr-1 xl:mr-3">
          <div class="bg-dvm-available mx-2 rounded-full w-2 h-2"></div>
          <p>Available</p>
        </div>
        <div class="flex items-center mr-1 xl:mr-3">
          <div class="w-2 h-2 mx-2 bg-{{ mySeatsColor }} rounded-full"></div>
          <p>My seats</p>
        </div>
        @if (isTopview) {
          <div class="flex items-center mr-1 xl:mr-3">
            <div class="bg-purple mx-2 rounded-full w-2 h-2"></div>
            <p>Selected</p>
          </div>
        }
        @if (!isTopview && isIsolatedActive) {
          <div class="flex items-center mr-1 xl:mr-3">
            <div class="w-2 h-2 mx-2 bg-{{ isolatedColor }} rounded-full"></div>
            <p>Isolated</p>
          </div>
        }
      </div>
      <div class="mx-3 border-gray-600 border-l h-8"></div>
      @if (showTutorialButton) {
        <sdc-button
          className="!bg-transparent disabled:opacity-30 !p-0 !min-w-0 disabled:hover:transform-none hover:scale-95 transition-transform"
          data-cy="open-tutorial-modal-button"
          theme="theme-sdc"
          type="button"
          variant="link"
          (onClick)="openTutorialQuestion()">
          <img
            ngSrc="/assets/img/information-icon.svg"
            alt="Information icon"
            width="25"
            height="25" />
        </sdc-button>
      }
    </div>
  }
  <!-- Mobile -->
  @if (showLegend && !is3dOpen) {
    <div class="xl:hidden flex items-center">
      <sdc-button
        class="header-legend-btn"
        className="disabled:opacity-30 !w-28 min-w-max h-8 !text-white align-middle transition-transform"
        theme="theme-sdc"
        type="button"
        variant="outline"
        (onClick)="openLegend()">
        Legend
      </sdc-button>
      @if (showTutorialButton) {
        <sdc-button
          className="!bg-transparent ml-2 !p-0 !min-w-0"
          data-cy="open-tutorial-modal-button"
          theme="theme-sdc"
          type="button"
          variant="link"
          (onClick)="openTutorialQuestion()">
          <img
            ngSrc="/assets/img/information-icon.svg"
            alt="Information icon"
            class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform"
            width="25"
            height="25" />
        </sdc-button>
      }
    </div>
  }

  @if (!showLegend && showTutorialButton) {
    <sdc-button
      className="!bg-transparent ml-2 !p-0 !min-w-0"
      data-cy="open-tutorial-modal-button"
      theme="theme-sdc"
      type="button"
      variant="link"
      (onClick)="openTutorialQuestion()">
      <img
        ngSrc="/assets/img/information-icon.svg"
        alt="Information icon"
        class="disabled:opacity-30 ml-2 disabled:hover:transform-none hover:scale-95 transition-transform"
        width="25"
        height="25" />
    </sdc-button>
  }
</div>
